// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventDetails .details-header {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/web/client/src/components/Programs/Events/Sidebar/EventDetails.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,mBAAA;AADJ","sourcesContent":[".EventDetails {\n\n  .details-header {\n    display: flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
